import React from 'react';

class notFound extends React.Component {
    render() {
        return (
            <div>
              Not Found.
            </div>
        )
    }
}

export default notFound;